import TIML from '../../../framework/timl.js';
import { AppConfig } from '../../config.js';
import { ShowPage, appendDataToListTable } from '../crud/shared.js';

export class AuthConfigDetails {
  static timl = `
    section.auth-overview-card
      .auth-overview-summary
        .auth-overview-thumbnail
          span.auth-overview-globe[aria-hidden="true"]
        .auth-overview-identity
          .auth-overview-title-row
            h3 {{ item.name }}
            span[class="auth-status-badge {{ item.statusClass }}"] {{ item.status }}
          .auth-overview-domain-row
            a.auth-overview-domain[href="{{ item.domainHref }}" target="_blank" rel="noreferrer" style="{{ item.domainLinkStyle }}"] {{ item.domain }}
            a.auth-overview-external[href="{{ item.domainHref }}" target="_blank" rel="noreferrer" aria-label="Open domain" style="{{ item.domainLinkStyle }}"]
      .auth-overview-stats
        .auth-overview-stat
          span.auth-overview-stat-icon.auth-overview-stat-users[aria-hidden="true"]
          strong {{ item.registrants }}
          span Registrants
        .auth-overview-stat
          span.auth-overview-stat-icon.auth-overview-stat-calendar[aria-hidden="true"]
          strong {{ item.createdDate }}
          span Created
        .auth-overview-stat
          span.auth-overview-stat-icon.auth-overview-stat-status[aria-hidden="true"]
          strong {{ item.systemStatus }}
          span System Status

    section.auth-details-card
      h2 Details
      .auth-details-grid
        .auth-detail-column
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-id[aria-hidden="true"] #
            span.auth-detail-label ID
            span.auth-detail-value {{ item.id }}
            button.auth-detail-copy[type="button" aria-label="Copy ID" data-copy-value="{{ item.id }}" onclick="AuthShow.copyDetailValue(this)"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-account[aria-hidden="true"]
            span.auth-detail-label Account ID
            span.auth-detail-value {{ item.accountId }}
            button.auth-detail-copy[type="button" aria-label="Copy Account ID" data-copy-value="{{ item.accountId }}" onclick="AuthShow.copyDetailValue(this)"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-person[aria-hidden="true"]
            span.auth-detail-label Name
            span.auth-detail-value {{ item.name }}
            span.auth-detail-spacer
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-key[aria-hidden="true"]
            span.auth-detail-label Auth App ID
            span.auth-detail-value#auth-app-id {{ item.authAppId }}
            button.auth-detail-copy[type="button" aria-label="Copy Auth App ID" data-copy-value="{{ item.authAppId }}" onclick="AuthShow.copyDetailValue(this)"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-globe[aria-hidden="true"]
            span.auth-detail-label Domain
            a.auth-detail-value.auth-detail-domain[href="{{ item.domainHref }}" target="_blank" rel="noreferrer" style="{{ item.domainLinkStyle }}"] {{ item.domain }}
            a.auth-detail-external[href="{{ item.domainHref }}" target="_blank" rel="noreferrer" aria-label="Open domain" style="{{ item.domainLinkStyle }}"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-list[aria-hidden="true"]
            span.auth-detail-label Description
            span.auth-detail-value {{ item.description }}
            span.auth-detail-spacer
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-code[aria-hidden="true"]
            span.auth-detail-label Custom CSS
            span.auth-detail-value {{ item.customCss }}
            span.auth-detail-spacer
        .auth-detail-column
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-calendar[aria-hidden="true"]
            span.auth-detail-label Created At
            span.auth-detail-value {{ item.createdAt }}
            span.auth-detail-spacer
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-calendar[aria-hidden="true"]
            span.auth-detail-label Updated At
            span.auth-detail-value {{ item.updatedAt }}
            span.auth-detail-spacer
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-person[aria-hidden="true"]
            span.auth-detail-label Created By
            span.auth-detail-value {{ item.createdBy }}
            button.auth-detail-copy[type="button" aria-label="Copy Created By" data-copy-value="{{ item.createdBy }}" onclick="AuthShow.copyDetailValue(this)"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-person[aria-hidden="true"]
            span.auth-detail-label Updated By
            span.auth-detail-value {{ item.updatedBy }}
            button.auth-detail-copy[type="button" aria-label="Copy Updated By" data-copy-value="{{ item.updatedBy }}" onclick="AuthShow.copyDetailValue(this)"]
          .auth-detail-row
            span.auth-detail-icon.auth-detail-icon-users[aria-hidden="true"]
            span.auth-detail-label Registrants
            span.auth-registrant-count {{ item.registrants }}
            span.auth-detail-spacer
  `;
}

export class AuthApiEndpointTable {
  static render() {
    const fragment = document.createDocumentFragment();
    const table = document.createElement('table');
    table.className = 'auth-api-table';

    const thead = document.createElement('thead');
    const headingRow = document.createElement('tr');
    ['API Endpoint', 'Requests (30d)', 'Last Used', 'Actions'].forEach((label, index) => {
      const th = document.createElement('th');
      th.textContent = label;
      if (index === 1) {
        const info = document.createElement('span');
        info.className = 'auth-api-info';
        info.title = 'Requests made during the last 30 days';
        info.setAttribute('aria-label', info.title);
        info.textContent = 'i';
        th.appendChild(info);
      }
      headingRow.appendChild(th);
    });
    thead.appendChild(headingRow);
    table.appendChild(thead);

    const tbody = document.createElement('tbody');
    AuthShow.apiEndpointDefinitions.forEach(endpoint => {
      const row = document.createElement('tr');
      row.setAttribute('data-endpoint-key', endpoint.key);

      const endpointCell = document.createElement('td');
      endpointCell.className = 'auth-api-endpoint-cell';
      const endpointLayout = document.createElement('div');
      endpointLayout.className = 'auth-api-endpoint-layout';
      const status = document.createElement('span');
      status.className = 'auth-api-status-dot';
      status.setAttribute('aria-label', 'Available');
      const method = document.createElement('span');
      method.className = `auth-api-method auth-api-method-${endpoint.method.toLowerCase()}`;
      method.textContent = endpoint.method;
      const identity = document.createElement('span');
      identity.className = 'auth-api-endpoint-identity';
      const path = document.createElement('a');
      const endpointUrl = AuthShow.getAuthEndpointUrl(endpoint.path);
      path.id = `auth-api-${endpoint.urlKey}-url`;
      path.className = 'api-example-url';
      path.setAttribute('href', endpointUrl);
      path.setAttribute('target', '_blank');
      path.setAttribute('rel', 'noreferrer');
      path.setAttribute('title', endpointUrl);
      path.setAttribute('data-url', endpointUrl);
      path.textContent = endpointUrl;
      const description = document.createElement('small');
      description.textContent = endpoint.description;
      identity.append(path, description);
      endpointLayout.append(status, method, identity);
      endpointCell.appendChild(endpointLayout);

      const requestsCell = document.createElement('td');
      const requestMetric = document.createElement('div');
      requestMetric.className = 'auth-api-request-metric';
      const requestCount = document.createElement('strong');
      requestCount.className = 'auth-api-request-count';
      requestCount.textContent = '—';
      const requestTrack = document.createElement('span');
      requestTrack.className = 'auth-api-request-track';
      const requestFill = document.createElement('span');
      requestFill.className = 'auth-api-request-fill';
      requestTrack.appendChild(requestFill);
      requestMetric.append(requestCount, requestTrack);
      requestsCell.appendChild(requestMetric);

      const lastUsedCell = document.createElement('td');
      lastUsedCell.className = 'auth-api-last-used';
      lastUsedCell.textContent = 'Never';

      const actionCell = document.createElement('td');
      const fetchButton = document.createElement('button');
      fetchButton.type = 'button';
      fetchButton.className = 'api-fetch-button';
      fetchButton.setAttribute('aria-label', `Get Fetch example for ${endpoint.path}`);
      const fetchIcon = document.createElement('span');
      fetchIcon.className = 'api-fetch-icon';
      fetchIcon.setAttribute('aria-hidden', 'true');
      const fetchLabel = document.createElement('span');
      fetchLabel.textContent = 'Fetch';
      fetchButton.append(fetchIcon, fetchLabel);
      fetchButton.onclick = () => AuthShow.copyFetchExample(endpoint.key, fetchButton);
      actionCell.appendChild(fetchButton);

      row.append(endpointCell, requestsCell, lastUsedCell, actionCell);
      tbody.appendChild(row);
    });

    table.appendChild(tbody);
    fragment.appendChild(table);
    return fragment;
  }
}

class AuthActivityRow {
  static props = ['action', 'collection', 'details', 'createdAt', 'createdBy'];
  static timl = `
    td {{ Props.action }}
    td {{ Props.collection }}
    td {{ Props.details }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.createdAt }}
    td.table-col-100 {{ Props.createdBy }}
  `;
}

export class AuthShow extends ShowPage {
  static timlComponents = {
    ...ShowPage.timlComponents,
    AuthApiEndpointTable
  };

  static apiEndpointDefinitions = [
    { key: 'register', urlKey: 'register', method: 'POST', path: '/register', description: 'Register a new user' },
    { key: 'login', urlKey: 'login', method: 'POST', path: '/login', description: 'Authenticate a user' },
    { key: 'resetPassword', urlKey: 'reset-password', method: 'POST', path: '/reset-password', description: 'Request a password reset' },
    { key: 'resendConfirmation', urlKey: 'resend-confirmation', method: 'POST', path: '/resend-email-verification', description: 'Resend a verification email' },
    { key: 'confirmEmail', urlKey: 'confirm-email', method: 'POST', path: '/confirm-email', description: 'Confirm a user email address' },
    { key: 'refreshToken', urlKey: 'refresh-token', method: 'POST', path: '/refresh-token', description: 'Refresh an access token' },
    { key: 'changePassword', urlKey: 'change-password', method: 'POST', path: '/change-password', description: 'Change an authenticated password' },
    { key: 'confirmResetPassword', urlKey: 'confirm-reset-password', method: 'POST', path: '/confirm-reset-password', description: 'Confirm a password reset' },
    { key: 'confirmLogin', urlKey: 'confirm-login', method: 'POST', path: '/confirm-login', description: 'Confirm an existing access token' },
    { key: 'authenticate', urlKey: 'authenticate', method: 'POST', path: '/authenticate', description: 'Validate an access token' },
    { key: 'logout', urlKey: 'logout', method: 'POST', path: '/logout', description: 'End the current session' }
  ];

  static getAuthEndpointUrl(path, authAppId = '', config = AppConfig, languageCode = globalThis.Translations?.langCode || 'en') {
    const baseUrl = String(config.authServiceApiBaseUrl || '').replace(/\/+$/, '');
    const language = String(languageCode || 'en').replace(/^\/+|\/+$/g, '') || 'en';
    const application = String(authAppId || '').replace(/^\/+|\/+$/g, '');
    const endpointPath = `/${String(path || '').replace(/^\/+/, '')}`;
    return `${baseUrl}/${language}${application ? `/${application}` : ''}${endpointPath}`;
  }

  static css = `
    ${ShowPage.css}

    .auth-show-header {
      display: flex;
      min-height: 68px;
      align-items: flex-start;
      justify-content: space-between;
      gap: 24px;
      margin: 0 28px;
      padding: 24px 0 10px;
    }

    .auth-show-header h1 {
      display: flex;
      min-width: 0;
      align-items: baseline;
      gap: 10px;
      padding-top: 5px;
      color: #151515;
      font-size: 20px;
      font-weight: 650;
      line-height: 30px;
      letter-spacing: -0.02em;
    }

    .auth-show-header h1 a {
      font-size: 14px;
      font-weight: 500;
    }

    .auth-show-separator {
      color: #555;
      font-size: 15px;
      font-weight: 400;
    }

    .auth-show-header h1 strong {
      min-width: 0;
      overflow: hidden;
      font-weight: 650;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .auth-show-actions {
      display: flex;
      flex: 0 0 auto;
      align-items: center;
      gap: 18px;
    }

    .auth-show-regenerate-form {width: auto;}

    .auth-show-action {
      display: inline-flex;
      min-height: 40px;
      align-items: center;
      justify-content: center;
      gap: 9px;
      padding: 0 17px;
      border: 1px solid #cfd1d4;
      border-radius: 7px;
      background: #fff;
      color: #23272c;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      white-space: nowrap;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    }

    .auth-show-action-primary {
      border-color: #0b0b0b;
      background: #0b0b0b;
      color: #fff;
    }

    .auth-show-action-primary:hover {background: #292929;color: #fff;}
    .auth-show-action-secondary:hover {background: #f5f5f4;color: #151515;}

    .auth-action-refresh-icon,
    .auth-action-edit-icon {
      width: 14px;
      height: 14px;
      flex: 0 0 14px;
      background-position: center;
      background-repeat: no-repeat;
    }

    .auth-action-refresh-icon {
      background-size: 14px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M13 5.3A5.5 5.5 0 1 0 13.1 11' stroke='white' stroke-width='1.4' stroke-linecap='round'/%3E%3Cpath d='M10.7 2.8H13v2.4' stroke='white' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    .auth-action-edit-icon {
      background-size: 14px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='m10.9 2.2 2.9 2.9-7.7 7.7-3.7.8.8-3.7 7.7-7.7Z' stroke='%2323272c' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    .auth-tabs {
      display: flex;
      gap: 35px;
      flex-wrap: wrap;
      margin: 0 28px;
      border-bottom: 1px solid #e2e3e5;
    }

    .auth-tab-button {
      position: relative;
      min-height: 46px;
      padding: 0 1px;
      border: 0;
      border-radius: 0;
      background: transparent;
      color: #353a41;
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
    }

    .auth-tab-button.active {
      background: transparent;
      color: #111;
      font-weight: 650;
    }

    .auth-tab-button.active::after {
      content: "";
      position: absolute;
      right: 0;
      bottom: -1px;
      left: 0;
      height: 2px;
      border-radius: 2px 2px 0 0;
      background: #141414;
    }

    .auth-tab-panel.hidden {
      display: none;
    }

    .auth-tab-panel {
      margin: 27px 28px 46px;
    }

    .auth-tab-panel[data-tab-panel="details"] {margin-top: 26px;}

    .auth-tab-panel:not([data-tab-panel="details"]) {
      padding: 0;
      overflow-x: auto;
      border: 1px solid #e1e2e4;
      border-radius: 8px;
      background: #fff;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.025);
    }

    #auth-config-details {margin: 0;}
    #auth-config-details.mt-15 {margin-top: 0;}

    .auth-overview-card,
    .auth-details-card {
      border: 1px solid #e1e2e4;
      border-radius: 8px;
      background: #fff;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.025);
    }

    .auth-overview-card {
      display: flex;
      min-height: 178px;
      align-items: center;
      gap: 34px;
      padding: 34px 42px;
      border-radius: 12px;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.055);
    }

    .auth-details-card > h2 {
      color: #21252a;
      font-size: 14px;
      font-weight: 650;
      line-height: 21px;
    }

    .auth-overview-summary {
      display: flex;
      flex: 1 1 46%;
      min-width: 0;
      align-items: center;
      gap: 30px;
    }

    .auth-overview-thumbnail {
      display: inline-flex;
      width: 90px;
      height: 90px;
      flex: 0 0 90px;
      align-items: center;
      justify-content: center;
      border-radius: 16px;
      background-color: #f0eeff;
      color: #746de2;
      box-shadow: 0 7px 16px rgba(73, 64, 154, 0.15);
    }

    .auth-overview-globe {
      width: 52px;
      height: 52px;
      background: center / 52px 52px no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none'%3E%3Ccircle cx='26' cy='26' r='20' stroke='%23746de2' stroke-width='2.6'/%3E%3Cpath d='M6 26h40M26 6c6.3 6.1 8.9 12.8 8.9 20S32.3 39.9 26 46c-6.3-6.1-8.9-12.8-8.9-20S19.7 12.1 26 6Z' stroke='%23746de2' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    .auth-overview-identity {min-width: 0;}

    .auth-overview-title-row {
      display: flex;
      min-width: 0;
      align-items: center;
      gap: 13px;
    }

    .auth-overview-identity h3 {
      margin: 0;
      overflow: hidden;
      color: #1c2025;
      font-size: 22px;
      font-weight: 650;
      line-height: 30px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .auth-status-badge {
      display: inline-flex;
      min-height: 22px;
      align-items: center;
      padding: 1px 10px;
      border-radius: 999px;
      background: #ededed;
      color: #52575d;
      font-size: 11px;
      font-weight: 500;
      line-height: 18px;
    }

    .auth-status-active {background: #e2f7e7;color: #33804c;}
    .auth-status-pending {background: #fff4d8;color: #8b6417;}
    .auth-status-inactive,
    .auth-status-disabled {background: #f2e8e7;color: #99463d;}

    .auth-overview-domain {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      color: #34383d;
      font-size: 13px;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .auth-overview-domain:hover {text-decoration: underline;}

    .auth-overview-domain-row {
      display: flex;
      min-width: 0;
      align-items: center;
      gap: 8px;
      margin-top: 20px;
    }

    .auth-overview-external {
      width: 17px;
      height: 17px;
      flex: 0 0 17px;
      border-radius: 4px;
      background: center / 13px 13px no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M9 3h4v4M13 3 7.5 8.5' stroke='%235a6067' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12 9v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3' stroke='%235a6067' stroke-linecap='round'/%3E%3C/svg%3E");
      opacity: 0.75;
    }

    .auth-overview-external:hover {background-color: #ededec;opacity: 1;}

    .auth-overview-stats {
      display: grid;
      width: min(48%, 510px);
      min-width: 390px;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      align-self: stretch;
    }

    .auth-overview-stat {
      display: flex;
      min-width: 0;
      align-items: center;
      justify-content: center;
      padding: 0 18px;
      border-left: 1px solid #e3e4e6;
      flex-direction: column;
      text-align: center;
    }

    .auth-overview-stat-icon {
      width: 34px;
      height: 34px;
      margin-bottom: 12px;
      border-radius: 50%;
      background-color: #f2f1ff;
      background-position: center;
      background-repeat: no-repeat;
    }

    .auth-overview-stat-users {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'%3E%3Ccircle cx='7' cy='6' r='2.3' stroke='%236d65d8' stroke-width='1.2'/%3E%3Cpath d='M2.7 14c.2-2.6 1.7-3.9 4.3-3.9s4.1 1.3 4.3 3.9M11 5a2.2 2.2 0 0 1 0 4.3m1.5 1c1.7.4 2.6 1.6 2.8 3.3' stroke='%236d65d8' stroke-width='1.2' stroke-linecap='round'/%3E%3C/svg%3E");background-size:18px;}
    .auth-overview-stat-calendar {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'%3E%3Crect x='3' y='4' width='12' height='11' rx='2' stroke='%236d65d8' stroke-width='1.2'/%3E%3Cpath d='M6 2.5v3M12 2.5v3M3.5 7h11' stroke='%236d65d8' stroke-width='1.2' stroke-linecap='round'/%3E%3C/svg%3E");background-size:18px;}
    .auth-overview-stat-status {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'%3E%3Cpath d='M2 9h3l1.7-4.5L9 13l2-6 1.3 2H16' stroke='%236d65d8' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");background-size:18px;}

    .auth-overview-stat strong {
      max-width: 100%;
      overflow: hidden;
      color: #252a30;
      font-size: 15px;
      font-weight: 650;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .auth-overview-stat > span:last-child {
      margin-top: 5px;
      color: #6d7278;
      font-size: 11px;
      line-height: 16px;
    }

    .auth-details-card {
      margin-top: 20px;
      padding: 20px 20px 12px;
    }

    .auth-details-card > h2 {margin-bottom: 13px;}

    .auth-details-grid {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      column-gap: 34px;
    }

    .auth-detail-column {min-width: 0;}

    .auth-detail-row {
      display: grid;
      min-height: 47px;
      grid-template-columns: 28px 92px minmax(0, 1fr) 20px;
      align-items: center;
      gap: 8px;
      border-bottom: 1px solid #e7e8e9;
      color: #3f454b;
      font-size: 11px;
      line-height: 17px;
    }

    .auth-detail-column .auth-detail-row:last-child {border-bottom: 0;}

    .auth-detail-icon {
      display: inline-flex;
      width: 22px;
      height: 22px;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      background-color: #eff6ff;
      background-position: center;
      background-repeat: no-repeat;
      color: #2563eb;
      font-size: 11px;
      font-weight: 650;
    }

    .auth-detail-icon-account {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Crect x='2.5' y='3.5' width='11' height='9' rx='1.5' stroke='%232563eb'/%3E%3Cpath d='M3 6h10M5 9h3' stroke='%232563eb' stroke-linecap='round'/%3E%3C/svg%3E");}
    .auth-detail-icon-person {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Ccircle cx='8' cy='5' r='2.2' stroke='%232563eb'/%3E%3Cpath d='M3.8 13c.2-2.7 1.6-4 4.2-4s4 1.3 4.2 4' stroke='%232563eb' stroke-linecap='round'/%3E%3C/svg%3E");}
    .auth-detail-icon-key {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Ccircle cx='5.3' cy='6.3' r='2.7' stroke='%232563eb'/%3E%3Cpath d='m7.2 8.2 5.2 5.2m-2.7-2.7 1.4-1.4' stroke='%232563eb' stroke-linecap='round'/%3E%3C/svg%3E");}
    .auth-detail-icon-globe {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Ccircle cx='8' cy='8' r='5.5' stroke='%232563eb'/%3E%3Cpath d='M2.5 8h11M8 2.5c2.8 3 2.8 8 0 11-2.8-3-2.8-8 0-11Z' stroke='%232563eb'/%3E%3C/svg%3E");}
    .auth-detail-icon-list {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M6 4h7M6 8h7M6 12h7' stroke='%232563eb' stroke-linecap='round'/%3E%3Ccircle cx='3' cy='4' r='.8' fill='%232563eb'/%3E%3Ccircle cx='3' cy='8' r='.8' fill='%232563eb'/%3E%3Ccircle cx='3' cy='12' r='.8' fill='%232563eb'/%3E%3C/svg%3E");}
    .auth-detail-icon-code {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='m5.5 4-3 4 3 4M10.5 4l3 4-3 4M9 2.5 7 13.5' stroke='%232563eb' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");}
    .auth-detail-icon-calendar {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Crect x='2.5' y='3.5' width='11' height='10' rx='1.5' stroke='%232563eb'/%3E%3Cpath d='M5 2v3M11 2v3M3 6.5h10' stroke='%232563eb' stroke-linecap='round'/%3E%3C/svg%3E");}
    .auth-detail-icon-users {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Ccircle cx='6' cy='5' r='2' stroke='%232563eb'/%3E%3Cpath d='M2 12c.2-2.3 1.5-3.5 4-3.5s3.8 1.2 4 3.5M10 4a2 2 0 0 1 0 4m1.5 1c1.5.4 2.3 1.4 2.5 3' stroke='%232563eb' stroke-linecap='round'/%3E%3C/svg%3E");}

    .auth-detail-label {color: #343a40;font-weight: 500;white-space: nowrap;}
    .auth-detail-value {
      min-width: 0;
      overflow: hidden;
      color: #42484f;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    a.auth-detail-value {color: #343a40;text-decoration: none;}
    a.auth-detail-value:hover {text-decoration: underline;}

    .auth-detail-copy,
    .auth-detail-external {
      display: inline-block;
      width: 20px;
      height: 20px;
      padding: 0;
      border-radius: 4px;
      background: center / 13px 13px no-repeat transparent;
      opacity: 0.7;
    }

    .auth-detail-copy {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Crect x='5.2' y='4.7' width='7.2' height='8' rx='1.2' stroke='%235a6067'/%3E%3Cpath d='M3.7 10.8h-.2a1.2 1.2 0 0 1-1.2-1.2V3.5a1.2 1.2 0 0 1 1.2-1.2h5.6a1.2 1.2 0 0 1 1.2 1.2v.1' stroke='%235a6067' stroke-linecap='round'/%3E%3C/svg%3E");}
    .auth-detail-external {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M9 3h4v4M13 3 7.5 8.5' stroke='%235a6067' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12 9v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3' stroke='%235a6067' stroke-linecap='round'/%3E%3C/svg%3E");}
    .auth-detail-copy:hover,
    .auth-detail-external:hover {background-color: #ededec;opacity: 1;}

    .auth-registrant-count {
      display: inline-flex;
      width: fit-content;
      min-width: 28px;
      min-height: 24px;
      align-items: center;
      justify-content: center;
      padding: 2px 9px;
      border-radius: 999px;
      background: #f0efff;
      color: #655bd0;
      font-size: 11px;
      font-weight: 650;
    }

    .api-copy-status {
      display: block;
      margin-top: 5px;
      color: #2f6f3e;
      font-size: 10px;
      white-space: nowrap;
    }

    .auth-api-table,
    .auth-section-table {
      width: 100%;
      margin: 0;
      border-collapse: collapse;
      table-layout: fixed;
      color: #3d434a;
      font-size: 12px;
    }

    .auth-api-table,
    .auth-activity-table {min-width: 760px;}

    .auth-activity-table {table-layout: auto;}

    .auth-api-table thead,
    .auth-section-table thead {border: 0;}
    .auth-api-table thead th,
    .auth-section-table thead th {
      height: 47px;
      padding: 12px 20px;
      border-bottom: 1px solid #e2e4e7;
      background: #fafafa;
      color: #5f666e;
      font-size: 11px;
      font-weight: 500;
      text-align: left;
    }

    .auth-api-table thead th:first-child {width: 48%;}
    .auth-api-table thead th:nth-child(2) {width: 23%;}
    .auth-api-table thead th:nth-child(3) {width: 15%;}
    .auth-api-table thead th:last-child {width: 14%;text-align: right;}

    .auth-api-info {
      display: inline-flex;
      width: 14px;
      height: 14px;
      align-items: center;
      justify-content: center;
      margin-left: 6px;
      border: 1px solid #a5abb2;
      border-radius: 50%;
      color: #777e86;
      font-size: 9px;
      font-weight: 650;
      vertical-align: 1px;
    }

    .auth-api-table tbody tr,
    .auth-section-table tbody tr {background: #fff;}
    .auth-api-table tbody tr:hover,
    .auth-section-table tbody tr:hover {background: #fbfbfc;}
    .auth-api-table tbody td,
    .auth-section-table tbody td {
      height: 72px;
      padding: 12px 20px;
      border-bottom: 1px solid #e7e8ea;
      color: #414850;
      vertical-align: middle;
    }
    .auth-api-table tbody tr:last-child td,
    .auth-section-table tbody tr:last-child td {border-bottom: 0;}

    .auth-api-endpoint-layout {
      display: flex;
      min-width: 0;
      align-items: center;
      gap: 14px;
    }

    .auth-api-status-dot {
      width: 7px;
      height: 7px;
      flex: 0 0 7px;
      border-radius: 50%;
      background: #27ae60;
    }

    .auth-api-method {
      display: inline-flex;
      min-width: 48px;
      min-height: 23px;
      flex: 0 0 auto;
      align-items: center;
      justify-content: center;
      padding: 2px 9px;
      border-radius: 7px;
      background: #f0efff;
      color: #6259c9;
      font-size: 10px;
      font-weight: 650;
      line-height: 16px;
    }

    .auth-api-method-get {background: #e9f7ee;color: #317a49;}

    .auth-api-endpoint-identity {
      display: flex;
      min-width: 0;
      flex-direction: column;
      gap: 3px;
    }

    .auth-api-endpoint-identity a {
      overflow: hidden;
      color: #282d33;
      font-size: 12px;
      font-weight: 650;
      line-height: 17px;
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .auth-api-endpoint-identity a:hover {text-decoration: underline;}

    .auth-api-endpoint-identity small {
      overflow: hidden;
      color: #697078;
      font-size: 11px;
      line-height: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .auth-simple-list-row {
      display: flex;
      min-width: 0;
      align-items: center;
      gap: 16px;
    }

    .auth-simple-list-identity {
      display: flex;
      min-width: 0;
      flex-direction: column;
      gap: 3px;
    }

    .auth-simple-list-identity strong {
      overflow: hidden;
      color: #282d33;
      font-size: 12px;
      font-weight: 650;
      line-height: 17px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .auth-simple-list-identity a,
    .auth-simple-list-identity small {
      overflow: hidden;
      color: #697078;
      font-size: 11px;
      font-weight: 400;
      line-height: 16px;
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .auth-simple-list-identity a:hover {color: #282d33;text-decoration: underline;}

    .auth-documentation-icon {
      width: 30px;
      height: 30px;
      flex: 0 0 30px;
      border-radius: 8px;
      background-color: #f2f1ff;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' fill='none'%3E%3Cpath d='M4 2.5h7l3 3v10H4v-13Z' stroke='%236d65d8' stroke-width='1.2' stroke-linejoin='round'/%3E%3Cpath d='M11 2.5v3h3M6.5 9h5M6.5 12h4' stroke='%236d65d8' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 16px 16px;
    }

    .auth-hosted-table,
    .auth-documentation-table {min-width: 540px;}

    .auth-activity-table thead th,
    .auth-activity-table tbody td {padding-right: 20px;padding-left: 20px;}

    #auth-activity-empty {
      margin: 0;
      padding: 34px 20px;
      color: #697078;
      text-align: center;
    }

    .auth-api-request-metric {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .auth-api-request-count {
      width: 38px;
      flex: 0 0 38px;
      color: #343a41;
      font-size: 11px;
      font-weight: 650;
      text-align: right;
    }

    .auth-api-request-track {
      display: block;
      width: 78px;
      height: 4px;
      overflow: hidden;
      border-radius: 99px;
      background: #e7e8eb;
    }

    .auth-api-request-fill {
      display: block;
      width: 0;
      height: 100%;
      border-radius: inherit;
      background: #7168da;
    }

    .auth-api-last-used {color: #5f666e;white-space: nowrap;}

    .auth-api-table tbody td:last-child {text-align: right;}
    .api-fetch-button {
      display: inline-flex;
      min-height: 34px;
      align-items: center;
      justify-content: center;
      gap: 7px;
      padding: 0 12px;
      border: 1px solid #d9dce0;
      border-radius: 7px;
      background: #fff;
      color: #424951;
      font-size: 11px;
      font-weight: 500;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }
    .api-fetch-button:hover {background: #f5f5f5;color: #171a1e;}

    .api-fetch-icon {
      width: 11px;
      height: 11px;
      background: center / 11px 11px no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='m3.5 2.2 5.7 3.8-5.7 3.8V2.2Z' stroke='%23565d65' stroke-width='1.1' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    #auth-activity-table {
      margin-top: 0;
    }

    @media (max-width: 1150px) {
      .auth-overview-card {align-items: stretch;flex-direction: column;}
      .auth-overview-stats {
        width: 100%;
        min-width: 0;
        min-height: 130px;
        padding-top: 22px;
        border-top: 1px solid #e3e4e6;
      }
      .auth-overview-stat:first-child {border-left: 0;}
    }

    @media (max-width: 880px) {
      .auth-details-grid {grid-template-columns: 1fr;}
      .auth-detail-column:first-child .auth-detail-row:last-child {border-bottom: 1px solid #e7e8e9;}
    }

    @media (max-width: 650px) {
      .auth-show-header {align-items: stretch;flex-direction: column;margin: 0 20px;padding-top: 20px;}
      .auth-show-actions {align-items: stretch;flex-direction: column;gap: 10px;}
      .auth-show-regenerate-form,
      .auth-show-action {width: 100%;}
      .auth-tabs {gap: 22px;margin: 10px 20px 0;overflow-x: auto;flex-wrap: nowrap;}
      .auth-tab-button {flex: 0 0 auto;}
      .auth-tab-panel {margin-right: 20px;margin-left: 20px;}
      .auth-overview-card {gap: 24px;padding: 26px 22px;}
      .auth-overview-summary {gap: 18px;}
      .auth-overview-thumbnail {width: 72px;height: 72px;flex-basis: 72px;border-radius: 13px;}
      .auth-overview-globe {width: 42px;height: 42px;background-size: 42px 42px;}
      .auth-overview-title-row {align-items: flex-start;flex-direction: column;gap: 5px;}
      .auth-overview-identity h3 {font-size: 19px;line-height: 25px;}
      .auth-overview-domain-row {margin-top: 11px;}
      .auth-overview-stat {padding-right: 6px;padding-left: 6px;}
      .auth-overview-stat strong {font-size: 13px;}
      .auth-details-card {padding-right: 14px;padding-left: 14px;}
      .auth-details-grid {column-gap: 0;}
      .auth-detail-row {grid-template-columns: 28px 84px minmax(0, 1fr) 20px;gap: 6px;}
    }
  `;

  static get regenerateAuthAppIdAction() {
    return `${API.resourceUrl('authConfigs', Routing.params.id)}/regenerate-auth-app-id`;
  }

  static timl = `
    header.auth-show-header
      h1
        a[href="/auth"] Authentication
        span.auth-show-separator >
        strong#name
          span.loading-ellipse
      .auth-show-actions
        form.auth-show-regenerate-form[method="POST" action="{{ Routing.routeObject.regenerateAuthAppIdAction }}" handler="AuthShow.regenerateAuthAppIdHandler"]
          button#regenerate-auth-app-id-button.auth-show-action.auth-show-action-primary[type="submit"]
            span.auth-action-refresh-icon[aria-hidden="true"]
            span.auth-action-label Regenerate Auth API ID
        a#share-button.auth-show-action.auth-show-action-secondary[href="/auth/{{ Routing.params.id }}/edit"]
          span.auth-action-edit-icon[aria-hidden="true"]
          span Edit
    .auth-tabs
      button.auth-tab-button.active[type="button" data-tab-button="details" onclick="AuthShow.switchTab('details')"] Details
      button.auth-tab-button[type="button" data-tab-button="api" onclick="AuthShow.switchTab('api')"] API Endpoints
      button.auth-tab-button[type="button" data-tab-button="hosted" onclick="AuthShow.switchTab('hosted')"] Hosted Pages
      button.auth-tab-button[type="button" data-tab-button="documentation" onclick="AuthShow.switchTab('documentation')"] Documentation
      button.auth-tab-button[type="button" data-tab-button="activity" onclick="AuthShow.switchTab('activity')"] Recent Activity

    div.auth-tab-panel[data-tab-panel="details"]
      div#auth-config-details.mt-15 Loading...

    div.auth-tab-panel.hidden[data-tab-panel="api"]
      <AuthApiEndpointTable>

    div.auth-tab-panel.hidden[data-tab-panel="hosted"]
      table.auth-section-table.auth-hosted-table
        thead
          tr
            th Hosted Page
        tbody
          tr
            td
              .auth-simple-list-row
                span.auth-api-status-dot[aria-label="Available"]
                .auth-simple-list-identity
                  strong Registration
                  a#auth-standalone-register-url[href="#"] Loading...
          tr
            td
              .auth-simple-list-row
                span.auth-api-status-dot[aria-label="Available"]
                .auth-simple-list-identity
                  strong Login
                  a#auth-standalone-login-url[href="#"] Loading...
          tr
            td
              .auth-simple-list-row
                span.auth-api-status-dot[aria-label="Available"]
                .auth-simple-list-identity
                  strong Registration Complete
                  a#auth-standalone-registered-url[href="#"] Loading...
          tr
            td
              .auth-simple-list-row
                span.auth-api-status-dot[aria-label="Available"]
                .auth-simple-list-identity
                  strong Resend Confirmation
                  a#auth-standalone-resend-confirmation-url[href="#"] Loading...
          tr
            td
              .auth-simple-list-row
                span.auth-api-status-dot[aria-label="Available"]
                .auth-simple-list-identity
                  strong Forgot Password
                  a#auth-standalone-forgot-password-url[href="#"] Loading...
          tr
            td
              .auth-simple-list-row
                span.auth-api-status-dot[aria-label="Available"]
                .auth-simple-list-identity
                  strong Password Reset
                  a#auth-standalone-password-reset-url[href="#"] Loading...
          tr
            td
              .auth-simple-list-row
                span.auth-api-status-dot[aria-label="Available"]
                .auth-simple-list-identity
                  strong Confirm Email
                  a#auth-standalone-confirm-email-url[href="#"] Loading...

    div.auth-tab-panel.hidden[data-tab-panel="documentation"]
      table.auth-section-table.auth-documentation-table
        thead
          tr
            th Documentation
        tbody
          tr
            td
              .auth-simple-list-row
                span.auth-documentation-icon[aria-hidden="true"]
                .auth-simple-list-identity
                  strong Make an API POST
                  small Learn how to call an authentication endpoint.
          tr
            td
              .auth-simple-list-row
                span.auth-documentation-icon[aria-hidden="true"]
                .auth-simple-list-identity
                  strong Customize standalone forms
                  small Change the appearance of your hosted authentication pages.

    div.auth-tab-panel.hidden[data-tab-panel="activity"]
      table#auth-activity-table.auth-section-table.auth-activity-table
        thead
          tr
            th Action
            th Collection
            th Details
            th.table-col-100.pr-4 Created At
            th.table-col-100 Created By
        tbody#auth-activity-rows.fade
      p#auth-activity-empty.hidden No recent authentication activity yet.
  `;

  static formatOverviewDate(value) {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';

    return new Intl.DateTimeFormat(globalThis.Translations?.langCode || 'en', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).format(date);
  }

  static mapItemToViewModel(item) {
    const domain = item.domain || '—';
    const domainHref = /^https?:\/\//i.test(domain) ? domain : (domain === '—' ? '#' : `https://${domain}`);
    const statusValue = String(item.status || 'active');
    const status = statusValue.charAt(0).toUpperCase() + statusValue.slice(1).toLowerCase();
    const statusClass = `auth-status-${statusValue.toLowerCase().replace(/[^a-z0-9-]/g, '')}`;
    const registrants = item.registrants ?? item.registrantCount ?? item.registrantsCount ?? 0;
    const systemStatusValue = item.systemStatusPercentage ?? item.uptimePercentage ?? item.systemStatus ?? 'Operational';
    const systemStatus = typeof systemStatusValue === 'number' || /^\d+(\.\d+)?$/.test(String(systemStatusValue))
      ? `${systemStatusValue}%`
      : String(systemStatusValue);

    return {
      item: {
        id: item.id || '—',
        accountId: item.accountId || '—',
        name: item.name || '—',
        authAppId: item.authAppId || '—',
        domain,
        domainHref,
        domainLinkStyle: domain === '—' ? 'pointer-events:none;' : '',
        status,
        statusClass,
        description: item.description || '—',
        customCss: item.custom_css || item.customCss || '—',
        createdDate: this.formatOverviewDate(item.createdAt),
        createdAt: Util.formatDate(item.createdAt) || '—',
        updatedAt: Util.formatDate(item.updatedAt) || '—',
        createdBy: item.createdBy || '—',
        updatedBy: item.updatedBy || '—',
        registrants,
        systemStatus
      }
    };
  }

  static async copyDetailValue(buttonEl) {
    const value = buttonEl?.getAttribute('data-copy-value');
    if (!value || value === '—') return;

    try {
      await navigator.clipboard.writeText(value);
      const previousLabel = buttonEl.getAttribute('aria-label') || 'Copy value';
      buttonEl.setAttribute('aria-label', 'Copied');
      buttonEl.classList.add('copied');
      setTimeout(() => {
        buttonEl.setAttribute('aria-label', previousLabel);
        buttonEl.classList.remove('copied');
      }, 1200);
    } catch (error) {
      window.prompt('Copy this value:', value);
    }
  }

  static setAuthEndpointUrls(authAppId) {
    const id = authAppId || Routing.params.id || '';
    this.currentAuthAppId = id;
    const authServiceBase = String(AppConfig.authServiceApiBaseUrl || '').replace(/\/+$/, '');
    const langCode = globalThis.Translations?.langCode || 'en';
    const urls = {
      '#auth-standalone-register-url': `${authServiceBase}/${langCode}/${id}/register`,
      '#auth-standalone-login-url': `${authServiceBase}/${langCode}/${id}/login`,
      '#auth-standalone-registered-url': `${authServiceBase}/${langCode}/${id}/registered`,
      '#auth-standalone-resend-confirmation-url': `${authServiceBase}/${langCode}/${id}/resend-confirmation`,
      '#auth-standalone-forgot-password-url': `${authServiceBase}/${langCode}/${id}/forgot-password`,
      '#auth-standalone-password-reset-url': `${authServiceBase}/${langCode}/${id}/password-reset`,
      '#auth-standalone-confirm-email-url': `${authServiceBase}/${langCode}/${id}/confirm-email`
    };

    Object.entries(urls).forEach(([selector, url]) => {
      const el = document.querySelector(selector);
      if (el) {
        if (el.classList.contains('api-example-url')) {
          el.setAttribute('data-url', url);
          el.setAttribute('title', url);
        } else {
          el.innerText = url;
        }
        if (el.tagName === 'A') {
          el.setAttribute('href', url);
        }
      }
    });

    this.apiEndpointDefinitions.forEach(endpoint => {
      const el = document.querySelector(`#auth-api-${endpoint.urlKey}-url`);
      if (!el) return;

      const url = this.getAuthEndpointUrl(endpoint.path, id);
      el.textContent = url;
      el.setAttribute('href', url);
      el.setAttribute('data-url', url);
      el.setAttribute('title', url);
    });
  }

  static getFetchExamples(authAppId) {
    const id = authAppId || Routing.params.id || '';
    const languageCode = globalThis.Translations?.langCode || 'en';
    const authServiceBase = String(AppConfig.authServiceApiBaseUrl || '').replace(/\/+$/, '');
    const authBase = `${authServiceBase}/${languageCode}/${id}`;
    const testEmail = this.getSuggestedTestEmail();
    const testPassword = 'ExamplePassword123!';

    return {
      register: `fetch("${authBase}/register", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    email: "${testEmail}",
    password: "${testPassword}",
    confirmEmailUrl: "${AppConfig.appBaseUrl}/${languageCode}/${id}/confirm-email"
  })
}).then(response => response.json()).then(console.log);`,
      login: `fetch("${authBase}/login", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    email: "${testEmail}",
    password: "${testPassword}"
  })
}).then(response => response.json()).then(console.log);`,
      forgotPassword: `fetch("${authBase}/reset-password", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    email: "${testEmail}"
  })
}).then(response => response.json()).then(console.log);`,
      resendConfirmation: `fetch("${authBase}/resend-email-verification", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    email: "${testEmail}"
  })
}).then(response => response.json()).then(console.log);`,
      confirmEmail: `fetch("${authBase}/confirm-email", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    code: "YOUR_CODE"
  })
}).then(response => response.json()).then(console.log);`,
      refreshToken: `fetch("${authBase}/refresh-token", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    refreshToken: "YOUR_REFRESH_TOKEN"
  })
}).then(response => response.json()).then(console.log);`,
      changePassword: `fetch("${authBase}/change-password", {
  method: "POST",
  headers: {
    "Authorization": "Bearer YOUR_ACCESS_TOKEN",
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    currentPassword: "OldPassword123!",
    password: "NewPassword123!"
  })
}).then(response => response.json()).then(console.log);`,
      resetPassword: `fetch("${authBase}/reset-password", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    email: "${testEmail}"
  })
}).then(response => response.json()).then(console.log);`,
      confirmResetPassword: `fetch("${authBase}/confirm-reset-password", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    token: "YOUR_RESET_TOKEN",
    password: "${testPassword}"
  })
}).then(response => response.json()).then(console.log);`,
      confirmLogin: `fetch("${authBase}/confirm-login", {
  method: "POST",
  headers: {
    "Authorization": "Bearer YOUR_ACCESS_TOKEN",
    "Accept": "application/json"
  }
}).then(response => response.json()).then(console.log);`,
      authenticate: `fetch("${authBase}/authenticate", {
  method: "POST",
  headers: {
    "Authorization": "Bearer YOUR_ACCESS_TOKEN",
    "Accept": "application/json"
  }
}).then(response => response.json()).then(console.log);`,
      logout: `fetch("${authBase}/logout", {
  method: "POST",
  headers: {
    "Authorization": "Bearer YOUR_ACCESS_TOKEN",
    "Accept": "application/json"
  }
}).then(response => response.json()).then(console.log);`
    };
  }

  static getSuggestedTestEmail() {
    const email = Auth.user?.email || 'tester@gmail.com';
    const parts = email.split('@');
    const local = parts[0] || 'tester';
    const domain = parts[1] || 'gmail.com';
    const baseLocal = local.split('+')[0];
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');
    const timestampAlias = `${month}${day}${hour}${minute}`;
    return `${baseLocal}+${timestampAlias}@${domain}`;
  }

  static async copyFetchExample(exampleKey, buttonEl) {
    const examples = this.getFetchExamples(this.currentAuthAppId);
    const text = examples[exampleKey];
    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);
      this.showCopyStatus(buttonEl, `Copied ${exampleKey} fetch snippet.`);
    } catch (error) {
      window.prompt('Copy this fetch snippet:', text);
      this.showCopyStatus(buttonEl, `Opened ${exampleKey} fetch snippet for copying.`);
    }
  }

  static showCopyStatus(buttonEl, message) {
    TIML.remove('.api-copy-status');
    if (!buttonEl) return;
    buttonEl.insertAdjacentHTML('afterend', `<small class="api-copy-status">${message}</small>`);
  }

  static switchTab(tabName) {
    const selectedTab = tabName || 'details';

    document.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      panel.classList.toggle('hidden', panel.getAttribute('data-tab-panel') !== selectedTab);
    });

    document.querySelectorAll('[data-tab-button]').forEach((button) => {
      button.classList.toggle('active', button.getAttribute('data-tab-button') === selectedTab);
    });

    if (location.hash !== `#${selectedTab}`) {
      history.replaceState(null, '', `${location.pathname}#${selectedTab}`);
    }

    if (selectedTab === 'activity' && !this.activityLoaded) {
      this.loadRecentActivity();
    }
  }

  static renderAuthConfig(item) {
    const viewModel = this.mapItemToViewModel(item);
    document.querySelector('#name').innerText = viewModel.item.name;
    TIML.renderInto(document.querySelector('#auth-config-details'), AuthConfigDetails, viewModel);
    this.setAuthEndpointUrls(viewModel.item.authAppId === '—' ? '' : viewModel.item.authAppId);
    this.renderEndpointUsage(item.endpointUsage || {});
  }

  static renderEndpointUsage(endpointUsage) {
    const counts = this.apiEndpointDefinitions.map(endpoint => {
      const metric = endpointUsage[endpoint.path.replace(/^\//, '')] || endpointUsage[endpoint.key] || {};
      return Number(metric.requests) || 0;
    });
    const maximum = Math.max(1, ...counts);

    this.apiEndpointDefinitions.forEach((endpoint, index) => {
      const row = document.querySelector(`[data-endpoint-key="${endpoint.key}"]`);
      if (!row) return;
      const metric = endpointUsage[endpoint.path.replace(/^\//, '')] || endpointUsage[endpoint.key] || {};
      const count = counts[index];
      const countEl = row.querySelector('.auth-api-request-count');
      const fillEl = row.querySelector('.auth-api-request-fill');
      const lastUsedEl = row.querySelector('.auth-api-last-used');
      if (countEl) countEl.textContent = new Intl.NumberFormat().format(count);
      if (fillEl) fillEl.style.width = `${Math.round((count / maximum) * 100)}%`;
      if (lastUsedEl) lastUsedEl.textContent = metric.lastUsed ? Util.formatDate(metric.lastUsed) : 'Never';
    });
  }

  static isAuthActivityItem(item) {
    const sourceDomain = item?.details?.sourceDomain || '';
    const collectionKey = item?.details?.collectionKey || '';
    const authCollections = ['users', 'authConfigs', 'passwordResets', 'loginTokens', 'sessions'];

    const authSourceDomains = [
      new URL(AppConfig.authAppsApiBaseUrl).hostname,
      new URL(AppConfig.authServiceApiBaseUrl).hostname
    ];

    return authSourceDomains.includes(sourceDomain) || authCollections.includes(collectionKey);
  }

  static mapActivityItemToRowData(item) {
    return {
      action: item.action || '—',
      collection: item.details?.collectionKey || item.collectionKey || '—',
      details: item.details?.recordLabel || item.details?.message || item.details?.recordId || '—',
      createdAt: Util.formatDate(item.createdAt),
      createdBy: item.createdByEmail || item.createdBy || '—'
    };
  }

  static loadRecentActivity() {
    if (this.activityLoaded) return;
    const activityUrl = `${API.resourceUrl('activity')}?limit=50`;

    API.get(activityUrl)
      .then(data => {
        const allItems = Array.isArray(data?.data) ? data.data : [];
        const authItems = allItems
          .filter(item => this.isAuthActivityItem(item))
          .slice(0, 10);

        if (!authItems.length) {
          const emptyEl = document.querySelector('#auth-activity-empty');
          if (emptyEl) emptyEl.classList.remove('hidden');
          this.activityLoaded = true;
          return;
        }

        appendDataToListTable('#auth-activity-rows', authItems, AuthActivityRow, this.mapActivityItemToRowData);
        this.activityLoaded = true;
      })
      .catch(error => {
        console.error('auth activity error data:', error);
        const emptyEl = document.querySelector('#auth-activity-empty');
        if (emptyEl) {
          emptyEl.classList.remove('hidden');
          emptyEl.innerText = 'Authentication activity is temporarily unavailable.';
        }
        this.activityLoaded = true;
      });
  }

  static loadAuthConfig() {
    return API.get(API.resourceUrl('authConfigs', Routing.params.id))
      .then(data => {
        this.renderAuthConfig(data.data);
        return data;
      });
  }

  static javascript() {
    super.javascript();
    this.loadAuthConfig();
    this.activityLoaded = false;
    this.switchTab('details');
  }

  static regenerateAuthAppIdHandler(form, data) {
    const button = form.querySelector('#regenerate-auth-app-id-button');
    const buttonLabel = button?.querySelector('.auth-action-label');
    const existingNotice = form.querySelector('.auth-app-id-status');

    if (existingNotice) {
      existingNotice.remove();
    }

    if (buttonLabel) {
      buttonLabel.innerText = 'Regenerating...';
    }

    delete API.cache[API.resourceUrl('authConfigs', Routing.params.id)];

    this.loadAuthConfig()
      .then(() => {
        if (buttonLabel) {
          buttonLabel.innerText = 'Regenerate Auth API ID';
        }
        form.insertAdjacentHTML('beforeend', '<small class="auth-app-id-status" style="color:#2f6f3e;padding-left:10px;">Auth API ID regenerated.</small>');
      })
      .catch(() => {
        if (buttonLabel) {
          buttonLabel.innerText = 'Regenerate Auth API ID';
        }
        form.insertAdjacentHTML('beforeend', '<small class="auth-app-id-status" style="color:#b42318;padding-left:10px;">Unable to refresh the new Auth API ID.</small>');
      });
  }
}

globalThis.AuthShow = AuthShow;
